/**
 * Returns true if the given value is of type number.
 * @param {*} n
 */
const isNumeric = n => {
  const isNumberType = typeof n === 'number';
  const isValidNumber = !Number.isNaN(n);
  return isNumberType && isValidNumber;
};

export default isNumeric;
